module.exports = __webpack_public_path__ + "static/media/visit_list_white.a2e296a2.svg";